webpackJsonp([4],{

/***/ "+070":
/***/ (function(module, exports) {

module.exports = {
	"https": true,
	"ws": "data.whispeer.de",
	"wsPort": 443,
	"debug": false,
	"production": true,
	"workerScript": "assets/js/build/worker.bundle.js",
	"serviceWorker": {
		"enabled": false
	}
};

/***/ }),

/***/ "+tJ9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


window.startup = new Date().getTime();

window.jQuery = __webpack_require__("juYr");

"use strict";

var angular = __webpack_require__("aeQg");
var app = __webpack_require__("JdNe");
__webpack_require__("D1vM");
__webpack_require__("txTk");

angular.element(document).ready(function () {
   var $html = angular.element(document.documentElement);
   angular.bootstrap($html, [app.name], { strictDi: true });
   // Because of RequireJS we need to bootstrap the app app manually
   // and Angular Scenario runner won"t be able to communicate with our app
   // unless we explicitely mark the container as app holder
   // More info: https://groups.google.com/forum/#!msg/angular/yslVnZh9Yjk/MLi3VGXZLeMJ
   $html.addClass("ng-app");
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "02Tt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mainPage", function() { return mainPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "landingPage", function() { return landingPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoginPage", function() { return isLoginPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBusinessVersion", function() { return isBusinessVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSalesPage", function() { return isSalesPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loginPage", function() { return loginPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "goToBusiness", function() { return goToBusiness; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "goToSalesPage", function() { return goToSalesPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reloadApp", function() { return reloadApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIOS", function() { return isIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBlockedReturnUrl", function() { return isBlockedReturnUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setReturnUrl", function() { return setReturnUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUrlParameter", function() { return getUrlParameter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage_service__ = __webpack_require__("IJod");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("juYr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);


var h = __webpack_require__("S8e/").default;
var config = __webpack_require__("b/6L");
var MS_YEAR = 365 * 24 * 60 * 60 * 1000;
var loginStorage = __WEBPACK_IMPORTED_MODULE_0__storage_service__["withPrefix"]("whispeer.login");
var blockedReturnUrls = ["/b2c", "/recovery"];
var removeOther = function (ele) {
    ele.siblings().remove();
    if (!ele.parent().is("body")) {
        removeOther(ele.parent());
    }
    else {
        ele.hide();
    }
};
var setTopLocation = function (url) {
    var locale = h.getLanguageFromPath() || "";
    if (__WEBPACK_IMPORTED_MODULE_0__storage_service__["storageInfo"].broken && url !== "/") {
        //if you read this code, welcome to my personal hell!
        /*
            So let me explain why this is necessary.
            Whispeer needs to store data locally, usually we use localStorage or indexedDB for that.
            This is an ugly quirks to move all content into an iframe and take the outer iframe as the
            storage area. This way the inner iframe could redirect as it wishes to without loosing the state.
            But why not use localStorage? We do, this is a fallback.
            Localstorage is not available in Safari Private Mode for example. Or if your disk is full.
        */
        console.log("promoting as main window");
        __WEBPACK_IMPORTED_MODULE_0__storage_service__["promoteMainWindow"]();
        if (window.frameElement) {
            removeOther(jQuery(window.frameElement));
        }
        else {
            jQuery(document.body).empty();
        }
        var body = jQuery(window.top.document.body);
        var iframe = jQuery("<iframe class='contentFallBack'></iframe>");
        body.append(iframe);
        iframe.attr("src", url);
    }
    else {
        window.top.location = "/" + locale + url;
    }
};
var mainPage = function () {
    setTopLocation("/main");
};
var landingPage = function () {
    setTopLocation("/");
};
var isLoginPage = function () {
    return window.top.location.pathname.indexOf("/login") !== -1;
};
var isBusinessVersion = function () { return !!false; };
var isSalesPage = function () {
    return window.top.location.href.indexOf(config.salesUrl) > -1;
};
var loginPage = function () {
    setTopLocation("/login");
};
var insertParam = function (key, value) {
    var currentSearch = document.location.search.substr(1).split('&');
    var newSearch = currentSearch.filter(function (val) { return val.split("=")[0] === key; });
    newSearch.push([key, value].join("="));
    document.location.search = newSearch.join('&');
};
var getParam = function (key) {
    var currentSearch = document.location.search.substr(1).split('&');
    return currentSearch.map(function (search) { return search.split("="); }).find(function (_a) {
        var k = _a[0];
        return k === key;
    });
};
var redirect = getParam("redirect");
var goToBusiness = function () {
    if (redirect) {
        return;
    }
    var expires = new Date(Date.now() + MS_YEAR);
    document.cookie = "business=1;path=/;expires=" + expires.toUTCString();
    insertParam("redirect", "true");
};
var goToSalesPage = function () {
    if (isSalesPage()) {
        return;
    }
    window.top.location.href = config.salesUrl;
};
var reloadApp = function () {
    return window.location.reload();
};
var isIOS = function () { return false; };
var isBlockedReturnUrl = function (url) {
    return blockedReturnUrls.filter(function (blockedUrl) {
        return url.indexOf(blockedUrl) !== -1;
    }).length > 0;
};
var setReturnUrl = function (url) {
    if (isBlockedReturnUrl(url)) {
        return;
    }
    loginStorage.set("returnUrl", url);
};
var getUrlParameter = function (param) {
    var search = window.top.location.search;
    var pairs = search.substr(1).split("&");
    var result = h.array.find(pairs.map(function (pair) {
        if (pair.indexOf("=") !== -1) {
            return {
                key: pair.substr(0, pair.indexOf("=")),
                value: pair.substr(pair.indexOf("=") + 1)
            };
        }
        else {
            return {
                key: pair,
                value: ""
            };
        }
    }), function (pair) {
        return pair.key === param;
    });
    if (result) {
        return result.value;
    }
};


/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Mbi2");
__webpack_require__("hWdg");
module.exports = __webpack_require__("+tJ9");


/***/ }),

/***/ "1IZJ":
/***/ (function(module, exports) {

module.exports = {
	"hashVersion": 3,
	"socket": {
		"autoConnect": true,
		"autoReconnect": true
	},
	"businessUrl": "https://business.whispeer.de",
	"salesUrl": "/sales",
	"serviceWorker": {
		"enabled": false
	}
};

/***/ }),

/***/ "4PxX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_service__ = __webpack_require__("EFCD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird__ = __webpack_require__("fp6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_helper__ = __webpack_require__("S8e/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idb__ = __webpack_require__("enoJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_idb__);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;



 // tslint:disable-line:no-unused-variable
var REINIT_CACHE_TIMEOUT = 2000;
var cachesDisabled = false;
var openDatabase = function () {
    return __WEBPACK_IMPORTED_MODULE_3_idb___default.a.open("whispeerCache", 10, function (upgradeDB) {
        var objectStore = upgradeDB.createObjectStore('cache', { keyPath: "id" });
        objectStore.createIndex("created", "created", { unique: false });
        objectStore.createIndex("used", "used", { unique: false });
        objectStore.createIndex("type", "type", { unique: false });
        objectStore.createIndex("size", "size", { unique: false });
    }).catch(function (e) {
        console.warn("Disabling indexedDB caching due to error", e);
        cachesDisabled = true;
        return Promise.reject(e);
    });
};
var initCache = function () { return cachesDisabled = false; };
try {
    indexedDB.deleteDatabase("whispeer");
}
catch (e) { }
var followCursorUntilDone = function (cursorPromise, action) {
    return __WEBPACK_IMPORTED_MODULE_1_bluebird__["try"](function () { return __awaiter(_this, void 0, void 0, function () {
        var cursor;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, cursorPromise];
                case 1:
                    cursor = _a.sent();
                    _a.label = 2;
                case 2:
                    if (!cursor) return [3 /*break*/, 4];
                    action(cursor);
                    return [4 /*yield*/, cursor.continue()];
                case 3:
                    cursor = _a.sent();
                    return [3 /*break*/, 2];
                case 4: return [2 /*return*/];
            }
        });
    }); });
};
var Cache = /** @class */ (function () {
    function Cache(name, options) {
        this.name = name;
        this.cacheDisabled = false;
        this.options = options || {};
        this.options.maxEntries = this.options.maxEntries || 100;
        this.options.maxBlobSize = this.options.maxBlobSize || 1 * 1024 * 1024;
    }
    Cache.deleteDatabase = function () {
        cachesDisabled = true;
        return __WEBPACK_IMPORTED_MODULE_3_idb___default.a.delete("whispeerCache").then(function () {
            setTimeout(function () {
                initCache();
            }, REINIT_CACHE_TIMEOUT);
        });
    };
    Cache.sumSize = function (arr) {
        return arr.reduce(function (prev, cur) {
            return prev + cur.size;
        }, 0);
    };
    Cache.prototype.store = function (id, data, blobs) {
        var _this = this;
        if (this.isDisabled()) {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird__["resolve"]();
        }
        if (blobs && !__WEBPACK_IMPORTED_MODULE_2__helper_helper__["default"].array.isArray(blobs)) {
            blobs = [blobs];
        }
        if (blobs && this.options.maxBlobSize !== -1 && Cache.sumSize(blobs) > this.options.maxBlobSize) {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird__["resolve"]();
        }
        var cacheEntry = {
            data: JSON.stringify(data),
            created: new Date().getTime(),
            used: new Date().getTime(),
            id: this.getID(id),
            type: this.name,
            size: 0,
            blobs: []
        };
        if (blobs) {
            cacheEntry.blobs = blobs;
            cacheEntry.size = Cache.sumSize(blobs);
        }
        return __WEBPACK_IMPORTED_MODULE_1_bluebird__["try"](function () { return __awaiter(_this, void 0, void 0, function () {
            var db, tx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, openDatabase()];
                    case 1:
                        db = _a.sent();
                        console.info("Storing in indexeddb " + this.getID(id));
                        tx = db.transaction('cache', 'readwrite');
                        tx.objectStore('cache').put(cacheEntry);
                        return [4 /*yield*/, tx.complete];
                    case 2:
                        _a.sent();
                        db.close();
                        return [2 /*return*/];
                }
            });
        }); }).catch(__WEBPACK_IMPORTED_MODULE_0__error_service__["errorServiceInstance"].criticalError);
    };
    Cache.prototype.contains = function (id) {
        var _this = this;
        if (this.isDisabled()) {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird__["resolve"](false);
        }
        return __WEBPACK_IMPORTED_MODULE_1_bluebird__["try"](function () { return __awaiter(_this, void 0, void 0, function () {
            var db, tx, count;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, openDatabase()];
                    case 1:
                        db = _a.sent();
                        tx = db.transaction("cache", "readonly");
                        return [4 /*yield*/, tx.objectStore("cache").count(this.name + "/" + id)];
                    case 2:
                        count = _a.sent();
                        db.close();
                        return [2 /*return*/, count > 0];
                }
            });
        }); });
    };
    Cache.prototype.get = function (id) {
        var _this = this;
        if (this.isDisabled()) {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird__["reject"](new Error("Cache is disabled " + this.name));
        }
        /*
        var cacheResult = this._db.cache.where("id").equals(this.name + "/" + id);

        this._db.cache.where("id").equals(this.name + "/" + id).modify({ used: new Date().getTime() });
        */
        return __WEBPACK_IMPORTED_MODULE_1_bluebird__["try"](function () { return __awaiter(_this, void 0, void 0, function () {
            var db, tx, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, openDatabase()];
                    case 1:
                        db = _a.sent();
                        tx = db.transaction("cache", "readonly");
                        return [4 /*yield*/, tx.objectStore("cache").get(this.name + "/" + id)];
                    case 2:
                        data = _a.sent();
                        if (typeof data === "undefined") {
                            throw new Error("cache miss for " + this.getID(id));
                        }
                        data.data = JSON.parse(data.data);
                        data.blobs = data.blobs || [];
                        data.blobs = data.blobs.map(function (blob) {
                            if (typeof blob === "string") {
                                return __WEBPACK_IMPORTED_MODULE_2__helper_helper__["default"].dataURItoBlob(blob);
                            }
                            return blob;
                        });
                        if (data.blobs.length === 1) {
                            data.blob = data.blobs[0];
                        }
                        db.close();
                        return [2 /*return*/, data];
                }
            });
        }); });
    };
    /**
     * get all cache entries as a dexie collection.<
     * @return {Bluebird<any>} Promise containing all cache entries as a dexie collection.
     */
    Cache.prototype.all = function () {
        if (this.isDisabled()) {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird__["resolve"]([]);
        }
        var entries = [];
        return this.cursorEach(function (cursor) { return entries.push(cursor.value); }, "readonly").then(function () { return entries; });
    };
    Cache.prototype.getID = function (id) {
        return this.name + "/" + id;
    };
    /**
     * delete a certain cache entry.
     * @param  {string}        id id of the entry
     * @return {Bluebird<any>}    [description]
     */
    Cache.prototype.delete = function (id) {
        var _this = this;
        if (this.isDisabled()) {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird__["resolve"]();
        }
        return __WEBPACK_IMPORTED_MODULE_1_bluebird__["try"](function () { return __awaiter(_this, void 0, void 0, function () {
            var db, tx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, openDatabase()];
                    case 1:
                        db = _a.sent();
                        tx = db.transaction("cache", "readwrite");
                        return [4 /*yield*/, tx.objectStore("cache").delete(this.getID(id))];
                    case 2:
                        _a.sent();
                        db.close();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    Cache.prototype.deleteAll = function () {
        if (this.isDisabled()) {
            return __WEBPACK_IMPORTED_MODULE_1_bluebird__["resolve"]();
        }
        var deleteRequests = [];
        return this.cursorEach(function (cursor) { return deleteRequests.push(cursor.delete()); }, "readwrite").then(function () { return __WEBPACK_IMPORTED_MODULE_1_bluebird__["all"](deleteRequests); });
    };
    Cache.prototype.cursorEach = function (action, transactionType) {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_1_bluebird__["try"](function () { return __awaiter(_this, void 0, void 0, function () {
            var db, tx, cursorPromise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, openDatabase()];
                    case 1:
                        db = _a.sent();
                        tx = db.transaction("cache", transactionType);
                        cursorPromise = tx.objectStore("cache").index("type").openCursor(this.name);
                        return [4 /*yield*/, followCursorUntilDone(cursorPromise, action)];
                    case 2:
                        _a.sent();
                        db.close();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    Cache.prototype.isDisabled = function () {
        return cachesDisabled || this.cacheDisabled;
    };
    Cache.disable = function () {
        cachesDisabled = true;
    };
    Cache.prototype.disable = function () {
        this.cacheDisabled = true;
    };
    return Cache;
}());
/* harmony default export */ __webpack_exports__["a"] = (Cache);


/***/ }),

/***/ "7Eh3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__("aeQg");

module.exports = angular.module("ssn.directives", []);

/***/ }),

/***/ "8I7s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./js/helper/helper.ts
var helper = __webpack_require__("S8e/");

// EXTERNAL MODULE: ../node_modules/socket.io-client/lib/index.js
var lib = __webpack_require__("+1g+");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ../node_modules/bluebird/js/browser/bluebird.js
var bluebird = __webpack_require__("fp6q");
var bluebird_default = /*#__PURE__*/__webpack_require__.n(bluebird);

// EXTERNAL MODULE: ./js/asset/observer.ts
var observer = __webpack_require__("SiYL");

// CONCATENATED MODULE: ./js/services/blobUploader.service.ts
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var blobUploader_service_BlobUploader = /** @class */ (function (_super) {
    __extends(BlobUploader, _super);
    function BlobUploader(socket, blob, blobid) {
        var _this = _super.call(this) || this;
        _this._doneBytes = 0;
        _this.upload = function () {
            if (!_this._uploadingPromise) {
                _this._uploadingPromise = _this._uploadPartUntilDone();
            }
            return _this._uploadingPromise;
        };
        _this._uploadPartUntilDone = function () {
            if (_this._doneBytes === _this._blob.size) {
                return bluebird["resolve"]();
            }
            return _this._uploadPart().then(function () {
                return _this._uploadPartUntilDone();
            });
        };
        _this._blob = blob;
        _this._blobid = blobid;
        _this._socket = socket;
        _this._reset();
        return _this;
    }
    BlobUploader.prototype._reset = function () {
        this._doneBytes = 0;
        this._partSize = BlobUploader.STARTPARTSIZE;
    };
    BlobUploader.sliceBlob = function (blob, start, end) {
        if (typeof blob.slice === "function") {
            return blob.slice(start, end);
        }
        if (typeof blob.webkitSlice === "function") {
            return blob.webkitSlice(start, end);
        }
        if (typeof blob.mozSlice === "function") {
            return blob.mozSlice(start, end);
        }
        return blob;
    };
    ;
    BlobUploader.prototype._halfSize = function () {
        this._partSize = Math.max(this._partSize / 2, BlobUploader.MINIMUMPARTSIZE);
    };
    ;
    BlobUploader.prototype._doubleSize = function () {
        this._partSize = Math.min(this._partSize * 2, BlobUploader.MAXIMUMPARTSIZE);
    };
    ;
    BlobUploader.prototype._uploadPart = function () {
        var _this = this;
        var uploadStarted = new Date().getTime(), uploadSize;
        return this._socket.awaitConnection().then(function () {
            var partToUpload = BlobUploader.sliceBlob(_this._blob, _this._doneBytes, _this._doneBytes + _this._partSize);
            uploadSize = partToUpload.size;
            var lastPart = _this._blob.size === _this._doneBytes + uploadSize;
            return _this._socket.emit("blob.uploadBlobPart", {
                blobid: _this._blobid,
                blobPart: partToUpload,
                doneBytes: _this._doneBytes,
                size: uploadSize,
                lastPart: lastPart
            });
        }).then(function (response) {
            if (response.reset) {
                console.warn("Restarting Upload");
                return _this._reset();
            }
            var uploadTook = new Date().getTime() - uploadStarted;
            if (uploadTook > BlobUploader.MAXIMUMTIME) {
                _this._halfSize();
            }
            else {
                _this._doubleSize();
            }
            _this._doneBytes += uploadSize;
            _this.notify(_this._doneBytes, "progress");
        }).catch(function (e) {
            console.error(e);
            _this._halfSize();
            return bluebird["delay"](5000);
        });
    };
    ;
    BlobUploader.MAXIMUMPARTSIZE = 1000 * 1000;
    BlobUploader.STARTPARTSIZE = 5 * 1000;
    BlobUploader.MINIMUMPARTSIZE = 1 * 1000;
    BlobUploader.MAXIMUMTIME = 2 * 1000;
    return BlobUploader;
}(observer["default"]));
/* harmony default export */ var blobUploader_service = (blobUploader_service_BlobUploader);

// EXTERNAL MODULE: ./js/services/location.manager.ts
var location_manager = __webpack_require__("02Tt");

// CONCATENATED MODULE: ./js/services/socket.service.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DisconnectError", function() { return DisconnectError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServerError", function() { return ServerError; });
var socket_service___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var APIVERSION = "0.0.4";
var debug = __webpack_require__("jcLW");


var config = __webpack_require__("b/6L");




var socketDebug = debug("whispeer:socket");
var socketError = debug("whispeer:socket:error");
var DisconnectError = helper["default"].createErrorType("disconnectedError");
var ServerError = helper["default"].createErrorType("serverError");
var socket_service_SOCKET_TIMEOUT = 60000;
var log = {
    timer: function (name) {
        var message = new Date().toLocaleTimeString() + ":" + name + "(" + Math.random() + ")";
        if (debug.enabled("whispeer:socket")) {
            console.time(message);
        }
        return message;
    },
    timerEnd: function (message) {
        if (debug.enabled("whispeer:socket")) {
            console.timeEnd(message);
        }
    }
};
var socket_service_SocketService = /** @class */ (function (_super) {
    socket_service___extends(SocketService, _super);
    function SocketService() {
        var _this = _super.call(this) || this;
        _this._interceptors = [];
        _this._domain = (config.https ? "https://" : "http://") + config.ws + ":" + config.wsPort;
        _this._autoReconnect = config.socket.autoReconnect;
        _this._autoConnect = config.socket.autoConnect;
        _this._lastRequestTime = 0;
        _this._loading = 0;
        _this.uploadObserver = new observer["default"]();
        _this._uploadingCounter = 0;
        _this.errors = {
            Disconnect: DisconnectError,
            Server: ServerError
        };
        _this.uploadBlob = function (blob, blobid, progress, cb) {
            if (_this._uploadingCounter > 3) {
                _this.uploadObserver.listenOnce(function () {
                    _this.uploadBlob(blob, blobid, progress, cb);
                }, "uploadFinished");
                return;
            }
            _this._uploadingCounter++;
            var uploader = new blobUploader_service(_this, blob, blobid);
            uploader.listen(function (doneBytes) {
                progress.progress(doneBytes);
            }, "progress");
            var uploadPromise = uploader.upload().then(function () {
                _this._uploadingCounter--;
                _this.uploadObserver.notify(blobid, "uploadFinished");
                _this.uploadObserver.notify(blobid, "uploadFinished:" + blobid);
            });
            return uploadPromise.nodeify(cb);
        };
        if (_this._autoConnect) {
            _this._connect();
        }
        if (_this._autoConnect && _this._autoReconnect) {
            window.setInterval(function () {
                try {
                    if (!_this._socket.connected) {
                        _this._socket.connect();
                    }
                }
                catch (e) {
                    socketError(e);
                }
            }, 10000);
        }
        return _this;
    }
    SocketService.prototype._connect = function () {
        var _this = this;
        this._socket = Object(lib["connect"])(this._domain, config.socket.options);
        this._socket.on("disconnect", function () {
            socketDebug("socket disconnected");
            _this._loading = 0;
            _this._uploadingCounter = 0;
        });
        this._socket.on("connect", function () {
            socketDebug("socket connected");
            _this.emit("whispeerPing", {});
            _this._socket.io.engine.on("heartbeat", function () {
                _this.notify(null, "heartbeat");
            });
        });
    };
    SocketService.prototype._emit = function (channel, request) {
        var _this = this;
        return new bluebird(function (resolve, reject) {
            var onDisconnect = function () {
                reject(new DisconnectError("Disconnected while sending"));
            };
            _this._socket.once("disconnect", onDisconnect);
            _this._socket.emit(channel, request, function (response) {
                _this._socket.off("disconnect", onDisconnect);
                resolve(response);
            });
        });
    };
    SocketService.prototype.getLoadingCount = function () {
        return this._loading;
    };
    ;
    SocketService.prototype.lastRequestTime = function () {
        return this._lastRequestTime;
    };
    ;
    SocketService.prototype.send = function (data) {
        this._socket.send(data);
    };
    SocketService.prototype.addInterceptor = function (interceptor) {
        this._interceptors.push(interceptor);
    };
    SocketService.prototype.isConnected = function () {
        return this._socket.connected;
    };
    SocketService.prototype.emit = function (channel, request, cb) {
        var _this = this;
        if (!this.isConnected()) {
            throw new DisconnectError("no connection");
        }
        var timer = log.timer("request on " + channel);
        request.version = APIVERSION;
        request.clientInfo = {"type":"browser","version":"0.3.15"};
        socketDebug("Request on " + channel, request);
        this._interceptors.forEach(function (interceptor) {
            if (interceptor.transformRequest) {
                request = interceptor.transformRequest(request);
            }
        });
        this._loading++;
        this.notify(null, "request");
        return this._emit(channel, request).timeout(socket_service_SOCKET_TIMEOUT).then(function (response) {
            socketDebug("Answer on " + channel, response);
            log.timerEnd(timer);
            if (response.alert) {
                alert(response.alert);
            }
            _this._lastRequestTime = response.serverTime;
            _this._interceptors.forEach(function (interceptor) {
                if (interceptor.transformResponse) {
                    response = interceptor.transformResponse(response, request);
                }
            });
            if (response.error) {
                socketError(response);
                throw new ServerError("server returned an error!", { response: response });
            }
            if (true) {
                if (response.isBusiness) {
                    Object(location_manager["goToBusiness"])();
                }
            }
            if (false) {
                if (response.loggedin && !response.isBusiness && !request.ignoreBusiness) {
                    goToSalesPage();
                }
            }
            return response;
        }).finally(function () {
            _this._loading--;
            _this.notify(null, "response");
        }).nodeify(cb);
    };
    SocketService.prototype.awaitNoRequests = function () {
        var _this = this;
        if (this._loading === 0) {
            return bluebird["resolve"]();
        }
        return new bluebird(function (resolve) {
            _this.listen(function () {
                if (_this._loading === 0) {
                    resolve();
                }
            }, "response");
        });
    };
    SocketService.prototype.awaitConnection = function () {
        var _this = this;
        return new bluebird(function (resolve) {
            if (_this.isConnected()) {
                resolve();
            }
            else {
                _this.once("connect", resolve);
            }
        });
    };
    SocketService.prototype.on = function (eventName, callback) {
        return this._socket.on(eventName, callback);
    };
    SocketService.prototype.once = function (eventName, callback) {
        return this._socket.once(eventName, callback);
    };
    /** definitly emits the request. might emit it multiple times! **/
    SocketService.prototype.definitlyEmit = function (channel, request) {
        var _this = this;
        var SOCKET_TIMEOUT = 10000;
        return this.awaitConnection().then(function () {
            return _this.emit(channel, request).timeout(SOCKET_TIMEOUT);
        }).catch(function (e) {
            console.error(e);
            return bluebird["delay"](500).then(function () {
                return _this.definitlyEmit(channel, request);
            });
        });
    };
    SocketService.prototype.channel = function (channel, callback) {
        this._socket.on(channel, function (data) {
            socketDebug("received data on " + channel);
            socketDebug(data);
            callback(null, data);
        });
    };
    SocketService.errors = {
        Disconnect: DisconnectError,
        Server: ServerError
    };
    return SocketService;
}(observer["default"]));
/* harmony default export */ var socket_service = __webpack_exports__["default"] = (new socket_service_SocketService());


/***/ }),

/***/ "D1vM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
* loginController
**/

var loginModule = __webpack_require__("JdNe");
__webpack_require__("raBi");

function loginController($scope, $location, loginDataService) {
	$scope.$watch(function () {
		return loginDataService.failureCode === 0;
	}, function (val) {
		if (val) {
			document.getElementById("mail").focus();
		}
	});

	$scope.$watch(function () {
		return loginDataService.failureCode === 1;
	}, function (val) {
		if (val) {
			document.getElementById("password").focus();
		}
	});

	loginDataService.loadedStorage.then(function () {
		var focus = window.top.whispeerStopAutoFocus;

		if ($scope.login) {
			if ($scope.login.identifier) {
				loginDataService.identifier = $scope.login.identifier;
				focus = true;
			}

			if ($scope.login.password) {
				loginDataService.password = $scope.login.password;
				focus = true;
			}
		}

		$scope.login = loginDataService;

		if (focus) {
			return;
		}

		if (loginDataService.identifier) {
			document.getElementById("password").focus();
		} else {
			document.getElementById("mail").focus();
		}
	});
}

loginController.$inject = ["$scope", "$location", "ssn.loginDataService"];

loginModule.controller("ssn.loginController", loginController);

/***/ }),

/***/ "EFCD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "errorServiceInstance", function() { return errorServiceInstance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js__ = __webpack_require__("jYBl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_whatwg_fetch__ = __webpack_require__("MCp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_whatwg_fetch__);


var ErrorService = /** @class */ (function () {
    function ErrorService() {
        var _this = this;
        this.criticalError = function (e) {
            return _this.logError(e);
        };
        this.logError = function (e) {
            if (e) {
                console.error(e);
                __WEBPACK_IMPORTED_MODULE_0_raven_js__["captureException"](e);
            }
        };
    }
    ErrorService.prototype.failOnErrorPromise = function (state, promise) {
        var _this = this;
        return promise.then(function () {
            state.success();
        }).catch(function (e) {
            state.failed();
            _this.criticalError(e);
        });
    };
    ;
    ErrorService.prototype.failOnError = function (state) {
        var _this = this;
        return function (e) {
            if (e) {
                state.failed();
                _this.criticalError(e);
            }
            else {
                state.success();
            }
        };
    };
    return ErrorService;
}());
var errorServiceInstance = new ErrorService();
/* harmony default export */ __webpack_exports__["default"] = (errorServiceInstance);


/***/ }),

/***/ "HXS4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__("aeQg");
module.exports = angular.module("ssn.runners", []);

/***/ }),

/***/ "IJod":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./js/services/Cache.ts
var Cache = __webpack_require__("4PxX");

// EXTERNAL MODULE: ../node_modules/bluebird/js/browser/bluebird.js
var bluebird = __webpack_require__("fp6q");
var bluebird_default = /*#__PURE__*/__webpack_require__.n(bluebird);

// EXTERNAL MODULE: ./js/helper/helper.ts
var helper = __webpack_require__("S8e/");

// CONCATENATED MODULE: ./js/services/Storage.ts


var LOCALSTORAGE_ERROR_DE = "Fehler!\n Kann Daten nicht lokal speichern!\n whispeer funktioniert ohne lokale Datenspeicherung (localstorage) nicht.\n Bitte aktivier es oder bitte uns um Hilfe: feedback@whispeer.de";
var LOCALSTORAGE_ERROR_EN = "Error!\n Can't store data locally!\n whispeer does not work without localstorage.\n Please enable it or ask us for help: feedback@whispeer.de";
var checkLocalStorage = function () {
    var rand = Math.random();
    try {
        localStorage.setItem("check-" + rand, "check-" + rand);
        if (localStorage.getItem("check-" + rand) === "check-" + rand) {
            localStorage.removeItem("check-" + rand);
            return true;
        }
        return false;
    }
    catch (e) {
        return false;
    }
};
if (!checkLocalStorage) {
    if (helper["default"].getLanguageFromPath() === "de") {
        alert(LOCALSTORAGE_ERROR_DE);
    }
    else {
        alert(LOCALSTORAGE_ERROR_EN);
    }
}
var Storage_Storage = /** @class */ (function () {
    function Storage(prefix) {
        var _this = this;
        this.get = function (key) {
            return localStorage.getItem(_this.calculateKey(key));
        };
        this.set = function (key, data) {
            return localStorage.setItem(_this.calculateKey(key), data);
        };
        this.remove = function (key) {
            return localStorage.removeItem(_this.calculateKey(key));
        };
        this.clear = function () {
            var usedKeys = Object.keys(localStorage);
            usedKeys.filter(function (key) {
                return key.indexOf(this._prefix) === 0;
            }, _this).forEach(function (key) {
                localStorage.setItem(key, "");
            });
            return bluebird["resolve"]();
        };
        this.save = function () {
            return bluebird["resolve"]();
        };
        this.calculateKey = function (key) {
            return _this._prefix + "." + key;
        };
        this.awaitLoading = function () { return bluebird["resolve"](); };
        this._prefix = prefix;
    }
    return Storage;
}());
/* harmony default export */ var services_Storage = (Storage_Storage);

// CONCATENATED MODULE: ./js/services/storage.service.ts
/* harmony export (immutable) */ __webpack_exports__["checkLocalStorage"] = storage_service_checkLocalStorage;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storageInfo", function() { return storageInfo; });
/* harmony export (immutable) */ __webpack_exports__["promoteMainWindow"] = promoteMainWindow;
/* harmony export (immutable) */ __webpack_exports__["withPrefix"] = withPrefix;


function storage_service_checkLocalStorage() {
    try {
        localStorage.setItem("localStorageTest", "localStorageTest");
        localStorage.removeItem("localStorageTest");
        return true;
    }
    catch (e) {
        return false;
    }
}
var storages = [];
var storageInfo = {
    Cache: new Cache["a" /* default */]("localStorage"),
    hasLocalStorage: storage_service_checkLocalStorage(),
    broken: false
};
function promoteMainWindow() {
    window.top.whispeerGetStorage = function (prefix) {
        return this.storages[prefix];
    };
}
function withPrefix(prefix) {
    if (!storages[prefix]) {
        try {
            storages[prefix] = new services_Storage(prefix);
        }
        catch (e) {
            storageInfo.broken = true;
        }
    }
    return storages[prefix];
}


/***/ }),

/***/ "JdNe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__("aeQg");
var config = __webpack_require__("b/6L");
__webpack_require__("RXrU");
__webpack_require__("Z7zX");
__webpack_require__("VqRR");
__webpack_require__("h+DX");
__webpack_require__("fiwE");

"use strict";
module.exports = angular.module("ssn.login", ["ngRaven", "ssn.directives", "ssn.runners"], ["$compileProvider", function ($compileProvider) {
	if (!config.debug) {
		$compileProvider.debugInfoEnabled(false);
	}
}]);

/***/ }),

/***/ "KEBJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__asset_observer__ = __webpack_require__("SiYL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("juYr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ScreenSizeService = /** @class */ (function (_super) {
    __extends(ScreenSizeService, _super);
    function ScreenSizeService() {
        var _this = _super.call(this) || this;
        _this.updateMobile = function () {
            var width = window.top.document.documentElement.clientWidth;
            var mobile = width < 1025;
            if (mobile !== _this.mobile) {
                _this.mobile = mobile;
                setTimeout(function () {
                    _this.notify(mobile);
                });
            }
        };
        jQuery(window.top).on("resize", _this.updateMobile);
        _this.updateMobile();
        return _this;
    }
    return ScreenSizeService;
}(__WEBPACK_IMPORTED_MODULE_0__asset_observer__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (new ScreenSizeService());


/***/ }),

/***/ "RXrU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var localizationLoader = __webpack_require__("iuSa").default;
var h = __webpack_require__("S8e/").default;
var Localize = __webpack_require__("n8tu").default;
var withPrefix = __webpack_require__("IJod").withPrefix;

var availableLanguages = ["en", "de"];

localizationLoader.setAvailableLanguages(availableLanguages);
localizationLoader.setFallBackLanguage(availableLanguages[0]);

var lang = h.getLanguageFromPath();
var pathLanguageAvailable = availableLanguages.indexOf(lang) > -1;

var localize = new Localize(pathLanguageAvailable ? lang : null);

if (false) {
	localize.loadOptionalLocaleExtension("assets/js/i18n/l_business_");

	var companyID = withPrefix("whispeer.token").get("companyID");

	if (companyID) {
		localize.loadOptionalLocaleExtension("assets/js/i18n/companies/l_" + companyID + "_");
	}
}

module.exports = localize;

/***/ }),

/***/ "S8e/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, process) {
function getGlobal() {
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        // eslint-disable-next-line no-undef
        return global;
    }
}
var glob = getGlobal();
var uuidPattern = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
var uuidRegexPattern = uuidPattern.replace(/x/g, "[a-fA-F0-9]").replace(/y/g, "[89abAB]");
var uuidRegex = new RegExp(uuidRegexPattern);
/** contains general helper functions */
var helper = {
    executeOnce: function (func) {
        var val;
        return function () {
            if (!val) {
                val = func();
            }
            return val;
        };
    },
    ensurePromise: function (p, cb) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return p.resolve(cb.apply(void 0, args));
        };
    },
    hasErrorId: function (response, id) {
        var errorData = response.errorData;
        return Object.keys(errorData).some(function (key) {
            return errorData[key].id === id;
        });
    },
    createErrorType: function (name) {
        function CustomError(message, extra) {
            var error = Error.call(this, message);
            this.name = name;
            this.extra = extra;
            this.message = error.message;
            this.stack = error.stack;
        }
        CustomError.prototype = Object.create(Error.prototype);
        CustomError.prototype.constructor = CustomError;
        return CustomError;
    },
    cacheResult: function (func) {
        var result;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (!result) {
                result = func.apply(this, args);
            }
            return result;
        };
    },
    cacheUntilSettled: function (func) {
        var resultPromise;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (!resultPromise) {
                resultPromise = func.apply(this, args);
            }
            resultPromise.finally(function () {
                resultPromise = null;
            });
            return resultPromise;
        };
    },
    randomIntFromInterval: function (min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    },
    generateUUID: function () {
        /* eslint-disable no-bitwise */
        var d = new Date().getTime();
        var uuid = uuidPattern.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16);
        });
        /* eslint-enable no-bitwise */
        return uuid;
    },
    repeatUntilTrue: function (Promise, func, delay) {
        function repeatFunc() {
            return func().then(function (res) {
                if (!res) {
                    return Promise.delay(delay).then(function () {
                        return repeatFunc();
                    });
                }
            });
        }
        return repeatFunc();
    },
    encodeParameters: function (parameters) {
        var keys = Object.keys(parameters);
        if (keys.length === 0) {
            return "";
        }
        var result = "?";
        keys.forEach(function (key) {
            result += key;
            if (parameters[key] !== null) {
                result += "=" + parameters[key];
            }
            result += "&";
        });
        result = result.substr(0, result.length - 1);
        return result;
    },
    getWeekNumber: function (d) {
        // Copy date so don't modify original
        d = new Date(+d);
        d.setHours(0, 0, 0);
        // Set to nearest Thursday: current date + 4 - current day number
        // Make Sunday's day number 7
        d.setDate(d.getDate() + 4 - (d.getDay() || 7));
        // Get first day of year
        var yearStart = new Date(d.getFullYear(), 0, 1).getTime();
        // Calculate full weeks to nearest Thursday
        var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
        // Return array of year and week number
        return weekNo;
    },
    getLanguageFromPath: function () {
        return window.top.location.pathname.split("/")[1];
    },
    or: function (v1, v2) {
        return v1 || v2;
    },
    and: function (v1, v2) {
        return v1 && v2;
    },
    not: function (func) {
        return function () {
            return !func.apply(this, arguments);
        };
    },
    addAfterHook: function (func, hook, thisArg) {
        return function () {
            func.apply(thisArg, arguments);
            hook.apply(thisArg, arguments);
        };
    },
    concatBuffers: function () {
        var bufs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            bufs[_i] = arguments[_i];
        }
        var len = 0, offset = 0;
        bufs.forEach(function (buf) {
            len += buf.byteLength;
        });
        var tmp = new Uint8Array(len);
        bufs.forEach(function (buf) {
            tmp.set(new Uint8Array(buf), offset);
            offset += buf.byteLength;
        });
        return tmp.buffer;
    },
    debouncePromise: function (Bluebird, func, time) {
        var timer = null;
        return function () {
            var args = arguments;
            if (timer) {
                clearTimeout(timer);
            }
            var promise = new Bluebird(function (resolve) {
                timer = setTimeout(function () {
                    resolve();
                }, time);
            }).then(function () {
                return func.apply(null, args);
            });
            return promise;
        };
    },
    debounce: function (func, time) {
        var timeout, args;
        return function () {
            args = arguments;
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(function () {
                func.apply(null, args);
            }, time);
        };
    },
    promisify: function (Promise, cb) {
        return new Promise(function (resolve, reject) {
            try {
                cb(function (e, result) {
                    if (e) {
                        reject(e);
                    }
                    else {
                        resolve(result);
                    }
                });
            }
            catch (e) {
                reject(e);
            }
        });
    },
    joinArraysToObject: function (config) {
        var result = [];
        var len = config[Object.keys(config)[0]].length;
        if (len === 0) {
            return result;
        }
        var i;
        for (i = 0; i < len; i += 1) {
            result.push({});
        }
        helper.objectEach(config, function (key, arrVal) {
            if (arrVal.length !== len) {
                throw new Error("arrays need to have the same length");
            }
            arrVal.forEach(function (val, index) {
                result[index][key] = val;
            });
        });
        return result;
    },
    capitaliseFirstLetter: function (string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
    lowercaseFirstLetter: function (string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
    },
    objectifyResult: function (name, cb) {
        return function (e, result) {
            var data = {};
            if (e) {
                cb(e);
            }
            else {
                data[name] = result;
                cb(null, data);
            }
        };
    },
    array: {
        isArray: function (arr) {
            return Object.prototype.toString.call(arr) === "[object Array]";
        },
        first: function (arr) {
            return arr[0];
        },
        last: function (arr) {
            return arr[arr.length - 1];
        },
        find: function (arr, func) {
            var results = arr.filter(func);
            if (results.length === 1) {
                return results[0];
            }
        },
        spreadByArray: function (toSpread, attributeNames) {
            var res = {};
            toSpread.forEach(function (val, index) {
                res[attributeNames[index]] = val;
            });
            return res;
        },
        contains: function (arr, element) {
            return arr.indexOf(element) > -1;
        },
        flatten: function (arr) {
            var i, result = [];
            for (i = 0; i < arr.length; i += 1) {
                if (arr[i] instanceof Array) {
                    result = result.concat(helper.array.flatten(arr[i]));
                }
                else {
                    result.push(arr[i]);
                }
            }
            return result;
        }
    },
    object: {
        deepSet: function (obj, partials, value) {
            obj = obj || {};
            if (partials.length === 0) {
                return value;
            }
            var curPartial = obj;
            partials.forEach(function (part, index) {
                if (index === partials.length - 1) {
                    curPartial[part] = value;
                }
                if (!curPartial[part]) {
                    curPartial[part] = {};
                }
            });
            return obj;
        },
        deepHas: function (obj, partials) {
            var hasDeep = true, currentPartial = obj;
            partials.forEach(function (partial) {
                if (currentPartial.hasOwnProperty(partial)) {
                    currentPartial = currentPartial[partial];
                }
                else {
                    hasDeep = false;
                }
            });
            return hasDeep;
        },
        deepGet: function (obj, partials) {
            var currentPart = obj, depth = 0, previousPart;
            if (partials.length === 0) {
                return {
                    depth: 0,
                    value: obj
                };
            }
            partials.forEach(function (partial) {
                if (typeof currentPart[partial] !== "undefined") {
                    previousPart = currentPart;
                    currentPart = currentPart[partial];
                    depth += 1;
                }
            });
            return {
                depth: depth,
                value: currentPart,
                parentValue: previousPart
            };
        },
        multipleFlatJoin: function (objs) {
            var result = {};
            function doJoin(base, obj) {
                helper.objectEach(obj, function (key, value) {
                    if (base.hasOwnProperty(key) && value !== base[key]) {
                        throw new Error("attribute already set!");
                    }
                    else {
                        result[key] = value;
                    }
                });
            }
            objs.map(function (e) {
                doJoin(result, e);
            });
            return result;
        }
    },
    pad: function (str, max) {
        str = str.toString();
        return str.length < max ? helper.pad("0" + str, max) : str;
    },
    canvasToBlob: function (canvas, type, cb) {
        canvas.toBlob(function (blob) {
            cb(null, blob);
        }, type);
    },
    blobToDataURI: function (blob, cb) {
        var reader = new FileReader();
        reader.onload = function () {
            cb(null, reader.result);
        };
        reader.readAsDataURL(blob);
    },
    dataURItoBlob: function (dataURI) {
        if (glob.atob && glob.Blob && glob.ArrayBuffer && glob.Uint8Array) {
            try {
                // convert base64 to raw binary data held in a string
                // doesn't handle URLEncoded DataURIs
                var byteString = atob(dataURI.split(",")[1]);
                // separate out the mime component
                var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
                // write the bytes of the string to an ArrayBuffer
                var ab = new ArrayBuffer(byteString.length);
                var ia = new Uint8Array(ab);
                for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                try {
                    return new Blob([ab], { type: mimeString });
                }
                catch (e) {
                    // TypeError old chrome and FF
                    window.BlobBuilder = window.BlobBuilder ||
                        window.WebKitBlobBuilder ||
                        window.MozBlobBuilder ||
                        window.MSBlobBuilder;
                    if (e.name === "TypeError" && window.BlobBuilder) {
                        var bb = new window.BlobBuilder();
                        bb.append([ab]);
                        return bb.getBlob(mimeString);
                    }
                    return false;
                }
            }
            catch (e) {
                return false;
            }
        }
        else {
            return false;
        }
    },
    /** calls all listeners */
    callListener: function (listener, arg1) {
        var i;
        for (i = 0; i < listener.length; i += 1) {
            try {
                listener[i](null, arg1);
            }
            catch (e) {
                console.log(e);
            }
        }
    },
    aggregateOnce: function (delayTime, callFunction) {
        var timerStarted = false;
        function doLoad() {
            timerStarted = false;
            callFunction();
        }
        return function () {
            if (!timerStarted) {
                timerStarted = true;
                window.setTimeout(doLoad, delayTime);
            }
        };
    },
    FullFiller: function () {
        var running = false, waiters = [];
        var success = false, failure = false, error;
        this.finish = function (e) {
            failure = !!e;
            success = !e;
            error = e;
            helper.callEach(waiters, [error]);
        };
        this.success = function () {
            if (!success && !failure) {
                success = true;
                helper.callEach(waiters);
            }
        };
        this.fail = function (e) {
            if (!success && !failure) {
                failure = true;
                error = e;
                helper.callEach(waiters, [error]);
            }
        };
        this.isSuccess = function () {
            return success;
        };
        this.start = function (cb) {
            if (!running && !success && !failure) {
                running = true;
                cb();
            }
        };
        this.await = function (cb) {
            if (success || failure) {
                cb(error);
            }
            else {
                waiters.push(cb);
            }
        };
    },
    delayMultiplePromise: function (Bluebird, delayTime, loadFunction, maxOnce) {
        var idsToLoad = [];
        var loadPromises = {}, loaderPromise;
        function doLoad() {
            var identifiers = idsToLoad.splice(0, maxOnce || idsToLoad.length);
            return loadFunction(identifiers).then(function (results) {
                loaderPromise = null;
                return results;
            }).map(function (result, i) {
                var id = identifiers[i];
                delete loadPromises[id];
                return {
                    id: id,
                    result: result
                };
            });
        }
        function getLoaderPromise() {
            if (!loaderPromise) {
                loaderPromise = Bluebird.delay(delayTime)
                    .then(function () { return doLoad(); });
            }
            return loaderPromise;
        }
        function awaitNextLoad(identifier) {
            return getLoaderPromise()
                .filter(function (res) { return res.id === identifier; })
                .then(function (remainingResults) {
                return remainingResults.length === 0 ?
                    awaitNextLoad(identifier) :
                    remainingResults[0].result;
            });
        }
        return function (identifier) {
            if (!loadPromises[identifier]) {
                idsToLoad.push(identifier);
                loadPromises[identifier] = awaitNextLoad(identifier);
            }
            return loadPromises[identifier];
        };
    },
    delayMultiple: function (delayTime, loadFunction, maxOnce) {
        var timerStarted = false;
        var idsToLoad = [];
        var loadListeners = {};
        function doLoad() {
            var identifier = idsToLoad.splice(0, maxOnce || idsToLoad.length);
            loadFunction(identifier, function (err, results) {
                if (err) {
                    throw err;
                }
                var i, curIdentifier, curListener;
                for (i = 0; i < results.length; i += 1) {
                    curIdentifier = identifier[i];
                    curListener = loadListeners[curIdentifier];
                    helper.callListener(curListener, results[i]);
                    delete loadListeners[curIdentifier];
                }
                if (idsToLoad.length === 0) {
                    timerStarted = false;
                }
                else {
                    window.setTimeout(doLoad, delayTime);
                }
            });
        }
        return function (identifier, cb) {
            if (loadListeners[identifier]) {
                loadListeners[identifier].push(cb);
            }
            else {
                loadListeners[identifier] = [cb];
                idsToLoad.push(identifier);
                if (!timerStarted) {
                    timerStarted = true;
                    window.setTimeout(doLoad, delayTime);
                }
            }
        };
    },
    setGeneralState: function (state, obj) {
        obj.saving = false;
        obj.success = false;
        obj.failure = false;
        switch (state) {
            case "saving":
                obj.saving = true;
                break;
            case "success":
                obj.success = true;
                break;
            case "failure":
            default:
                obj.failure = true;
                break;
        }
    },
    stringifyCertainAttributes: function (obj, attributes) {
        var attr, result = {};
        for (attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                if (attributes.indexOf(attr) > -1) {
                    result[attr] = JSON.stringify(obj[attr]);
                }
                else {
                    if (typeof obj[attr] === "object") {
                        throw new Error("value should not be stringified but is object");
                    }
                    result[attr] = obj[attr];
                }
            }
        }
        return result;
    },
    unStringifyCertainAttributes: function (obj, attributes) {
        var attr, result = {};
        for (attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                if (attributes.indexOf(attr) > -1) {
                    result[attr] = JSON.parse(obj[attr]);
                }
                else {
                    result[attr] = obj[attr];
                }
            }
        }
        return result;
    },
    newElement: function (Constructor) {
        return function (e) {
            return new Constructor(e);
        };
    },
    arraySubtract: function (original, subtractor) {
        var i, result = [];
        for (i = 0; i < original.length; i += 1) {
            if (subtractor.indexOf(original[i]) === -1) {
                result.push(original[i]);
            }
        }
        return result;
    },
    arrayUnique: function (arr) {
        var hashMap = {}, i, name, l = arr.length, result = [];
        for (i = 0; i < l; i += 1) {
            if (arr[i]) {
                hashMap[arr[i]] = arr[i];
            }
        }
        for (name in hashMap) {
            if (hashMap.hasOwnProperty(name)) {
                result.push(hashMap[name]);
            }
        }
        return result;
    },
    arrayEqual: function (arr1, arr2) {
        return arr1.length === arr2.length && helper.arraySubtract(arr1, arr2).length === 0 && helper.arraySubtract(arr2, arr1).length === 0;
    },
    deepEqual: function (obj1, obj2) {
        if (obj1 === obj2) {
            return true;
        }
        else if (typeof obj1 === "object" && typeof obj2 === "object") {
            var keys1 = Object.keys(obj1), keys2 = Object.keys(obj2);
            if (!helper.arrayEqual(keys1, keys2)) {
                return false;
            }
            var i, cur;
            for (i = 0; i < keys1.length; i += 1) {
                cur = keys1[i];
                if (!helper.deepEqual(obj1[cur], obj2[cur])) {
                    return false;
                }
            }
        }
        else {
            return false;
        }
        return true;
    },
    deepCopyArray: function (arr, depth) {
        var result = [], i;
        for (i = 0; i < arr.length; i += 1) {
            result[i] = helper.deepCopyObj(arr[i], depth - 1);
        }
        return result;
    },
    deepCopyObj: function (obj, depth) {
        if (typeof obj !== "object") {
            return obj;
        }
        if (depth < 0) {
            throw new Error("too deep");
        }
        if (obj instanceof Array) {
            return helper.deepCopyArray(obj, depth);
        }
        var attr, value, result = {};
        // Extend the base object
        for (attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                value = obj[attr];
                result[attr] = helper.deepCopyObj(value, depth - 1);
            }
        }
        return result;
    },
    extend: function (target, extender, depth, removeEmpty) {
        function shouldDeleteAttribute(value) {
            if (!removeEmpty) {
                return false;
            }
            return value === "" || value === null || (typeof value === "object" && Object.keys(value).length === 0);
        }
        if (!target) {
            return extender;
        }
        if (depth < 0) {
            throw new Error("too deep");
        }
        var attr, given, added;
        // Extend the base object
        for (attr in extender) {
            if (extender.hasOwnProperty(attr)) {
                target[attr] = target[attr] || {};
                given = target[attr];
                added = extender[attr];
                if (added !== undefined) {
                    if (typeof given === "object" && typeof added === "object" && !(added instanceof Array)) {
                        helper.extend(given, added, depth - 1, removeEmpty);
                    }
                    else {
                        target[attr] = added;
                    }
                    if (shouldDeleteAttribute(target[attr])) {
                        delete target[attr];
                    }
                }
            }
        }
        return target;
    },
    extendNoOverwrite: function (target, extender) {
        helper.objectEach(extender, function (key, value) {
            if (typeof target[key] === "undefined") {
                target[key] = helper.deepCopyObj(value);
            }
            else if (typeof target[key] === "object") {
                helper.extendNoOverwrite(target[key], value);
            }
        });
    },
    parseDecimal: function (e) {
        return parseInt(e, 10);
    },
    assert: function (bool) {
        if (!bool) {
            throw new Error("assertion not met!");
        }
    },
    qm: function (attr) {
        return function (obj) {
            return obj[attr];
        };
    },
    nop: function () { },
    objectJoin: function (obj1, obj2) {
        var result = {};
        helper.objectEach(obj1, function (key, value) {
            if (obj2.hasOwnProperty(key) && value !== obj2[key]) {
                if (typeof value === "object" && typeof obj2[key] === "object") {
                    result[key] = helper.objectJoin(value, obj2[key]);
                }
                else {
                    throw new Error("attribute set in both!");
                }
            }
            else {
                result[key] = value;
            }
        });
        helper.objectEach(obj2, function (key, value) {
            if (!obj1.hasOwnProperty(key)) {
                result[key] = value;
            }
        });
        return result;
    },
    objectEach: function (obj, cb, thisArg) {
        var attr;
        for (attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                cb.call(thisArg, attr, obj[attr]);
            }
        }
    },
    copyObj: function (obj) {
        var newObj = {}, attr;
        for (attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                newObj[attr] = obj[attr];
            }
        }
        return newObj;
    },
    containsOr: function (value) {
        var i;
        for (i = 1; i < arguments.length; i += 1) {
            if (arguments[i].indexOf(value) > -1) {
                return true;
            }
        }
        return false;
    },
    arrayToObject: function (arr, func) {
        var i, res = {};
        for (i = 0; i < arr.length; i += 1) {
            res[func(arr[i], i)] = arr[i];
        }
        return res;
    },
    removeArray: function (arr, val) {
        if (!arr) {
            return [];
        }
        var ax;
        while ((ax = arr.indexOf(val)) !== -1) {
            arr.splice(ax, 1);
        }
        return arr;
    },
    callEach: function (listener, args, returnFunction) {
        if (returnFunction === void 0) { returnFunction = function () { }; }
        var result;
        listener.forEach(function (theListener) {
            try {
                var currentResult = theListener.apply(null, args);
                if (result) {
                    result = returnFunction(result, currentResult);
                }
                else {
                    result = currentResult;
                }
            }
            catch (e) {
                console.log(e);
            }
        });
        return result;
    },
    objectMap: function (obj, func, thisArg) {
        var attr, res = {}, result;
        for (attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                result = func.call(thisArg, obj[attr], attr);
                if (result) {
                    res[attr] = result;
                }
            }
        }
        return res;
    },
    setAll: function (obj, value) {
        var attr;
        for (attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                if (typeof obj[attr] === "object") {
                    helper.setAll(obj, value);
                }
                else {
                    obj[attr] = value;
                }
            }
        }
    },
    deepGet: function (obj, key) {
        var i;
        var cur = obj;
        if (typeof key === "string") {
            key = [key];
        }
        if (!cur) {
            return;
        }
        for (i = 0; i < key.length; i += 1) {
            if (cur[key[i]]) {
                cur = cur[key[i]];
            }
            else {
                return;
            }
        }
        return cur;
    },
    deepSet: function (obj, key, value) {
        var toSet = key.pop();
        var branch = helper.deepGet(obj, key);
        if (branch) {
            branch[toSet] = value;
        }
        else {
            return false;
        }
    },
    toUrl: function (file) {
        var url;
        if (file.localURL) {
            return file.localURL;
        }
        if (typeof URL !== "undefined") {
            url = URL.createObjectURL(file);
        }
        else if (typeof webkitURL !== "undefined") {
            url = webkitURL.createObjectURL(file);
        }
        return url;
    },
    deepSetCreate: function (obj, keys, value) {
        var changed = false, cur = obj;
        keys.forEach(function (key, index) {
            if (index + 1 < keys.length) {
                if (!cur[key]) {
                    cur[key] = {};
                }
                cur = cur[key];
            }
            else if (cur[key] !== value) {
                cur[key] = helper.deepCopyObj(value);
                changed = true;
            }
        });
        return changed;
    },
    validateObjects: function validateObjectsF(reference, data, noValueCheck) {
        var key;
        for (key in data) {
            if (data.hasOwnProperty(key)) {
                if (!reference[key]) {
                    return false;
                }
                if (!noValueCheck) {
                    if (typeof reference[key] === "object") {
                        if (!helper.validateObjects(reference[key], data[key])) {
                            return false;
                        }
                    }
                    else if (typeof reference[key] === "function") {
                        if (!reference[key](data[key])) {
                            return false;
                        }
                    }
                    else if (reference[key] !== true) {
                        return false;
                    }
                }
            }
        }
        return true;
    },
    /** chars for a sid */
    codeChars: ["Q", "W", "E", "R", "T", "Z", "U", "I", "O", "P", "A", "S", "D", "F", "G", "H", "J", "K", "L", "Y", "X", "C", "V", "B", "N", "M", "q", "w", "e", "r", "t", "z", "u", "i", "o", "p", "a", "s", "d", "f", "g", "h", "j", "k", "l", "y", "x", "c", "v", "b", "n", "m", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
    /** get a file names extension */
    getExtension: function (filename) {
        var i = filename.lastIndexOf(".");
        return (i < 0) ? "" : filename.substr(i);
    },
    /** get a filenames name */
    getName: function (filename) {
        var i = filename.lastIndexOf(".");
        return (i < 0) ? filename : filename.substr(0, i);
    },
    /** just a function which moves on in step */
    passFunction: function () {
        this.apply(null, arguments);
    },
    /** order a certain ass-array correctly
    * @param object object to sort
    * @param order correct order (normal array)
    * @param getFunction which func to call on objects to get their "value"
    * @return ordered object
    */
    orderCorrectly: function (object, order, getFunction) {
        var i, j, results = [];
        for (i = 0; i < order.length; i += 1) {
            for (j = 0; j < object.length; j += 1) {
                if (object[j][getFunction]() === order[i]) {
                    results.push(object[j]);
                    object.splice(j, 1);
                    break;
                }
            }
        }
        return results;
    },
    isUUID: function (uuid) {
        return helper.isString(uuid) && uuid.match(uuidRegex);
    },
    /** is data an integer?
    * @param data value to check for int value
    * @return bool is integer?
    */
    isInt: function (data) {
        var y = parseInt(data, 10);
        if (isNaN(y)) {
            return false;
        }
        return y.toString() === data.toString();
    },
    /** is data an id?*/
    isID: function (data) {
        if (helper.isInt(data)) {
            data = parseInt(data, 10);
            return (data > 0);
        }
        return false;
    },
    isRealID: function (data) {
        if (typeof data !== "string") {
            return false;
        }
        var parts = data.split(":");
        if (parts.length !== 2) {
            return false;
        }
        if (parts[1].length !== 64) {
            return false;
        }
        if (!helper.isNickname(parts[0]) && !helper.isMail(parts[0])) {
            return false;
        }
        return true;
    },
    /** is data a valid nickname? */
    isNickname: function (data) {
        return (helper.isString(data) && data.length !== 0 && !!data.match(/^[A-z][A-z0-9]*$/));
    },
    /** is data an e-mail? */
    isMail: function (data) {
        var regex = /^.+@.+$/;
        return (helper.isString(data) && data.length !== 0 && regex.test(data));
    },
    /** is data a session Key (hex value with certain length) */
    isSessionKey: function (data) {
        return (helper.isset(data) && (data.length === 64 || data.length === 32) && helper.isHex(data));
    },
    isPassword: function (data) {
        return (helper.isHex(data) && data.length === 64);
    },
    isCurve: function (data) {
        if (data === "c256" || data === "256") {
            return true;
        }
        //TODO!
        return false;
    },
    isBase64: function (data) {
        return (helper.isset(data) && typeof data === "string" && !!data.match(/^[A-Za-z0-9\+\/=]|=[^=]|={3,}$/));
    },
    isSignature: function (data) {
        return helper.isHex(data);
    },
    isHex: function (data) {
        return (helper.isset(data) && typeof data === "string" && !!data.match(/^[A-Fa-f0-9]*$/));
    },
    /** typeof val == object? */
    isObject: function (val) {
        return (typeof val === "object");
    },
    /** is val set (not null/undefined) */
    isString: function (val) {
        return (val !== undefined && val !== null && typeof val === "string");
    },
    /** is val set (not null/undefined) */
    isset: function (val) {
        return (val !== undefined && val !== null);
    },
    /** checks if an array is set and attributes in that array are set.
    * @param arrayName the array to check
    * @param other attributes to check for
    * checks if arrayName[1][2][3][4]... is set where 1-inf are the given attributes.
    * helper function
    * @author Nilos
    */
    arraySet: function (arrayName) {
        var i = 1;
        var memory;
        if (helper.isset(arrayName)) {
            memory = arrayName;
        }
        else {
            return false;
        }
        for (i = 1; i < arguments.length; i += 1) {
            if (helper.isset(memory[arguments[i]])) {
                memory = memory[arguments[i]];
            }
            else {
                return false;
            }
        }
        return true;
    },
    nT: function (cb) {
        var nT = function nTf() {
            var args = arguments;
            if (typeof process !== "undefined") {
                process.nextTick(function () {
                    cb.apply(this, args);
                });
            }
            else {
                cb.apply(this, args);
            }
        };
        return nT;
    },
    /** step function
    * throws given errors
    * passes on all other stuff to given function
    */
    sF: function (cb) {
        var mysf = function sfFunction(err) {
            if (err) {
                console.log(err.stack);
                this(err);
                return;
            }
            var args = []; // empty array
            var i;
            // copy all other arguments we want to "pass through"
            for (i = 1; i < arguments.length; i += 1) {
                args.push(arguments[i]);
            }
            return cb.apply(this, args);
        };
        mysf.getRealFunction = function () {
            return cb;
        };
        return mysf;
    },
    /** handle Error function for step
    * passes given errors to callback but only those!
    * throws other errors.
    */
    hE: function (cb, errors) {
        return function (err) {
            if (err) {
                console.log(err);
                var passToNext = false;
                if (errors instanceof Array) {
                    var i;
                    for (i = 0; i < errors.length; i += 1) {
                        if (err instanceof errors[i]) {
                            passToNext = true;
                        }
                    }
                }
                else {
                    passToNext = err instanceof errors;
                }
                if (!passToNext) {
                    this(err);
                    return;
                }
            }
            return cb.apply(this, arguments);
        };
    },
    emptyUnion: function (arr1, arr2) {
        return helper.arraySubtract(arr1, arr2).length === arr1.length && helper.arraySubtract(arr2, arr1).length === arr2.length;
    },
    /** is needle in haystack? */
    inArray: function (haystack, needle) {
        var i = 0;
        for (i = 0; i < haystack.length; i += 1) {
            if (haystack[i] === needle) {
                return true;
            }
        }
        return false;
    },
    firstCapital: function (string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
};
/* harmony default export */ __webpack_exports__["default"] = (helper);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("h6ac"), __webpack_require__("pBGv")))

/***/ }),

/***/ "SiYL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extend", function() { return extend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__("fp6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_helper__ = __webpack_require__("S8e/");


var afterHooks = [];
var Observer = /** @class */ (function () {
    function Observer() {
        this._listeners = {};
        this._listenersOnce = {};
    }
    Observer.addAfterHook = function (listener) {
        afterHooks.push(listener);
    };
    ;
    Observer.prototype.listenOnce = function (fn, type) {
        type = type || "any";
        if (typeof this._listenersOnce[type] === "undefined") {
            this._listenersOnce[type] = [];
        }
        this._listenersOnce[type].push(fn);
    };
    Observer.prototype.listenPromise = function (type) {
        var that = this;
        return new __WEBPACK_IMPORTED_MODULE_0_bluebird__(function (resolve) {
            that.listenOnce(resolve, type);
        });
    };
    Observer.prototype.listen = function (fn, type) {
        type = type || "any";
        if (typeof this._listeners[type] === "undefined") {
            this._listeners[type] = [];
        }
        this._listeners[type].push(fn);
    };
    Observer.prototype.notify = function (data, type, returnF) {
        type = type || "any";
        if (!returnF) {
            returnF = function () { };
        }
        var listeners = this._listeners[type] || [];
        var listenersOnce = this._listenersOnce[type] || [];
        var subscribers = (listeners).concat(listenersOnce);
        this._listenersOnce[type] = [];
        var result = __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].callEach(subscribers, [data], returnF);
        if (type !== "any") {
            result = returnF(this.notify(data), result);
        }
        __WEBPACK_IMPORTED_MODULE_1__helper_helper__["default"].callEach(afterHooks);
        return result;
    };
    Observer.extend = function (obj) {
        var internalObserver = new Observer();
        obj.notify = internalObserver.notify.bind(internalObserver);
        obj.listenOnce = internalObserver.listenOnce.bind(internalObserver);
        obj.listenPromise = internalObserver.listenPromise.bind(internalObserver);
        obj.listen = internalObserver.listen.bind(internalObserver);
    };
    return Observer;
}());
/* harmony default export */ __webpack_exports__["default"] = (Observer);
var extend = function (obj) {
    Observer.extend(obj);
};


/***/ }),

/***/ "VqRR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var screenSizeService = __webpack_require__("KEBJ").default;

"use strict";

var directivesModule = __webpack_require__("7Eh3");

function mobileDirective() {
	return {
		scope: false,
		restrict: "A",
		link: function link(scope) {
			scope.mobile = screenSizeService.mobile;
			screenSizeService.listen(function (mobile) {
				scope.mobile = mobile;
			});
		}
	};
}

directivesModule.directive("mobile", [mobileDirective]);

/***/ }),

/***/ "WfiL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var sjcl = __webpack_require__("kHLR");
var h = __webpack_require__("S8e/").default;
var errors = __webpack_require__("a86h");
var helper = {
	hash: function hash(text) {
		return helper.bits2hex(sjcl.hash.sha256.hash(text));
	},
	hashPW: function hashPW(pw, salt) {
		return helper.bits2hex(sjcl.hash.sha256.hash(pw + salt));
	},
	getCurveName: function getCurveName(curve) {
		var curcurve;
		for (curcurve in sjcl.ecc.curves) {
			if (sjcl.ecc.curves.hasOwnProperty(curcurve)) {
				if (sjcl.ecc.curves[curcurve] === curve) {
					return curcurve;
				}
			}
		}

		throw new Error("curve not existing");
	},
	getCurve: function getCurve(curveName) {
		if (typeof curveName !== "string" || curveName.substr(0, 1) !== "c") {
			curveName = "c" + curveName;
		}

		if (sjcl.ecc.curves[curveName]) {
			return sjcl.ecc.curves[curveName];
		}

		throw new Error("invalidCurve");
	},
	hex2bits: function hex2bits(t) {
		if (t instanceof Array) {
			return t;
		}

		if (h.isHex(t)) {
			return sjcl.codec.hex.toBits(t);
		}

		//TODO
		throw new errors.InvalidHexError();
	},
	bits2hex: function bits2hex(t) {
		if (typeof t === "string") {
			return t;
		}

		return sjcl.codec.hex.fromBits(t);
	},
	sjclPacket2Object: function sjclPacket2Object(decoded) {
		var result = {
			ct: helper.bits2hex(decoded.ct),
			iv: helper.bits2hex(decoded.iv)
		};

		if (decoded.salt) {
			result.salt = helper.bits2hex(decoded.salt);
		}

		return result;
	},
	Object2sjclPacket: function Object2sjclPacket(data) {
		if (typeof data.salt === "string") {
			data.salt = helper.hex2bits(data.salt);
		}

		if (typeof data.iv === "string") {
			data.iv = helper.hex2bits(data.iv);
		}

		if (typeof data.ct === "string") {
			data.ct = helper.hex2bits(data.ct);
		}

		return sjcl.json.encode(data);
	}
};

module.exports = helper;

/***/ }),

/***/ "Z7zX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var templateUrl = __webpack_require__("cA1Q");

"use strict";

var directivesModule = __webpack_require__("7Eh3");

function savebuttonDirective() {
	return {
		transclude: true,
		scope: {
			state: "=state"
		},
		restrict: "E",
		templateUrl: templateUrl,
		replace: true,
		link: function link(scope, iElement, iAttrs) {
			scope.successIcon = "fa-check-circle";
			scope.initIcon = "fa-check-circle";
			scope.failureIcon = "fa-times-circle";

			if (iAttrs.initicon) {
				scope.initIcon = iAttrs.initicon;
			}

			if (iAttrs.successicon) {
				scope.successIcon = iAttrs.successicon;
			}

			if (iAttrs.failureicon) {
				scope.failureIcon = iAttrs.failureicon;
			}

			if (typeof iAttrs.noiniticon !== "undefined") {
				delete scope.initIcon;
			}
		}
	};
}

directivesModule.directive("savebutton", savebuttonDirective);

/***/ }),

/***/ "a86h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function extendError(ParentErrorClass, name) {
	if (ParentErrorClass.prototype instanceof Error || ParentErrorClass === Error) {
		var F = function F() {};
		var CustomError = function CustomError(message, data) {
			var _this = this;

			var tmp = new ParentErrorClass(message);
			tmp.name = this.name = name || "Error";

			_this.data = data;
			_this.stack = tmp.stack;
			_this.message = tmp.message;
			_this.name = name;

			return _this;
		};
		var SubClass = function SubClass() {};
		SubClass.prototype = ParentErrorClass.prototype;
		F.prototype = CustomError.prototype = new SubClass();
		CustomError.prototype.constructor = CustomError;

		return CustomError;
	} else {
		throw new Error("our error should inherit from error!");
	}
}

var InvalidDataError = extendError(Error, "InvalidDataError");
var InvalidHexError = extendError(InvalidDataError, "InvalidHexError");
var InvalidFilter = extendError(InvalidDataError, "InvalidFilter");

var SecurityError = extendError(Error, "SecurityError");
var AccessViolation = extendError(SecurityError, "AccessViolation");
var DecryptionError = extendError(SecurityError, "DecryptionError");
var ValidationError = extendError(SecurityError, "ValidationError");

var LoginError = extendError(Error, "LoginError");

module.exports = {
	SecurityError: SecurityError,
	AccessViolation: AccessViolation,
	DecryptionError: DecryptionError,
	ValidationError: ValidationError,

	InvalidDataError: InvalidDataError,
	InvalidHexError: InvalidHexError,
	InvalidFilter: InvalidFilter,

	LoginError: LoginError
};

/***/ }),

/***/ "b/6L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var h = __webpack_require__("S8e/").default;
var baseConfig = __webpack_require__("1IZJ");
var config = __webpack_require__("+070");

module.exports = h.extend(h.extend({}, baseConfig), config);

/***/ }),

/***/ "cA1Q":
/***/ (function(module, exports) {

var path = 'directives/saveButton.html';
var html = "<button data-ng-class=\"{'btn-saveButton--success': state.success || state.init, 'btn-saveButton--operation': state.pending, 'btn-saveButton--failure': state.failed}\" class=\"btn btn--saveButton\"> <i data-ng-if=\"state.success && successIcon\" class=\"fa fa-fw {{successIcon}}\"></i> <i data-ng-if=\"state.init && initIcon\" class=\"fa fa-fw {{initIcon}}\"></i> <i data-ng-if=\"state.failed && failureIcon\" class=\"fa fa-fw {{failureIcon}}\"></i> <i data-ng-if=state.pending class=\"saveButton-spinner fa fa-fw fa-spinner fa-spin\"></i> <span ng-transclude></span> </button> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "fiwE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
The MIT License

Copyright (c) 2012-2013 Coding Smackdown TV, http://codingsmackdown.tv
Changes by Nils Thenhausen (2014-2015), http://whispeer.com
Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
Enjoy!
*/

/*
* An AngularJS Localization Service
*
* Written by Jim Lavin
* http://codingsmackdown.tv
* Changes by Nils Thenhausen, http://whispeer.com
*/

var angular = __webpack_require__("aeQg");
var Localize = __webpack_require__("n8tu").default;
var localize = __webpack_require__("RXrU");
var jQuery = __webpack_require__("juYr");

function toReplacementObject(values) {
	var result = {};
	values.forEach(function (val) {
		var index = val.indexOf("=");

		result[val.substr(0, index)] = val.substr(index + 1, val.length);
	});

	return result;
}

function turnTagIntoElementArray(tag, i18nElements) {
	var attr,
	    k,
	    tags = [tag];
	for (attr in i18nElements) {
		if (i18nElements.hasOwnProperty(attr)) {
			for (k = 0; k < tags.length; k += 1) {
				if (typeof tags[k] === "string" && tags[k].indexOf(Localize.getReplacementString(attr)) > -1) {
					var result = tags[k].split(Localize.getReplacementString(attr));
					tags.splice(k, 1, result[0], i18nElements[attr], result[1]);
				}
			}
		}
	}

	return tags;
}

var _module = angular.module("localization", []);

// localization service responsible for retrieving resource files from the server and
// managing the translation dictionary
_module.provider("localize", function () {
	this.$get = ["$rootScope", function ($rootScope) {
		localize.listen(function () {
			$rootScope.$broadcast("localizeResourcesUpdates");
		}, "localizeResourcesUpdates");

		localize.initLocalizedResources();

		return localize;
	}];
});

// simple translation filter
// usage {{ TOKEN | i18n }}
_module.filter("i18n", ["localize", function () {
	var filter = function filter(input) {
		return localize.getLocalizedString(input);
	};
	filter.$stateful = true;
	return filter;
}]);

_module.filter("l", ["localize", function () {
	var filter = function filter(input) {
		return localize.getLocalizedString(input);
	};
	filter.$stateful = true;
	return filter;
}]);

var i18nDirective = function i18nDirective($compile, directiveName, allowHtml) {
	var directive = {
		restrict: "EAC",
		updateText: function updateText(scope, elm, token, i18nElements) {
			var values = token.split("|");

			i18nElements = i18nElements || [];

			// construct the tag to insert into the element
			var tag = localize.getLocalizedString(values.shift(), toReplacementObject(values));
			// update the element only if data was returned
			if (!tag) {
				return;
			}

			elm.html("");

			var tags = turnTagIntoElementArray(tag, i18nElements);

			tags.forEach(function (cur) {
				if (typeof cur === "string") {
					elm.append(allowHtml === true ? cur : document.createTextNode(cur));
				} else {
					cur.forEach(function (element) {
						elm.append(element.clone());
					});
				}
			});

			$compile(elm.contents())(scope);
		},

		compile: function compile(elm) {
			var elements = {};

			var children = elm.children();
			var k, child, attr;

			//get the html of all children
			for (k = 0; k < children.length; k += 1) {
				child = jQuery(children[k]);

				attr = child.attr("data-for");

				elements[attr] = elements[attr] || [];
				elements[attr].push(child);
			}

			elm.html("");

			return function (scope, elm, attrs) {
				scope.$on("localizeResourcesUpdates", function () {
					directive.updateText(scope, elm, attrs[directiveName], elements);
				});

				attrs.$observe(directiveName, function () {
					directive.updateText(scope, elm, attrs[directiveName], elements);
				});
			};
		}
	};

	return directive;
};

// translation directive that can handle dynamic strings
// updates the text value of the attached element
// usage <span data-i18n="TOKEN" ></span>
// or
// <span data-i18n="TOKEN|VALUE1|VALUE2" ></span>
_module.directive("i18n", ["$compile", "localize", function ($compile) {
	return i18nDirective($compile, "i18n", false);
}]);

_module.directive("i18nHtml", ["$compile", "localize", function ($compile) {
	return i18nDirective($compile, "i18nHtml", true);
}]);

// translation directive that can handle dynamic strings
// updates the attribute value of the attached element
// usage <span data-i18n-attr="TOKEN|ATTRIBUTE" ></span>
// or
// <span data-i18n-attr="TOKEN|ATTRIBUTE|VALUE1|VALUE2" ></span>
_module.directive("i18nAttr", ["localize", function () {
	var i18nAttrDirective = {
		restrict: "EAC",
		updateText: function updateText(elm, token) {
			var values = token.split("|"),
			    key = values.shift(),
			    attr = values.shift();
			// construct the tag to insert into the element
			var tag = localize.getLocalizedString(key, toReplacementObject(values));
			// update the element only if data was returned
			if (!tag) {
				return;
			}

			// insert the text into the atribute
			elm.attr(attr, tag);
		},
		link: function link(scope, elm, attrs) {
			scope.$on("localizeResourcesUpdates", function () {
				i18nAttrDirective.updateText(elm, attrs.i18nAttr);
			});

			attrs.$observe("i18nAttr", function (value) {
				i18nAttrDirective.updateText(elm, value);
			});
		}
	};

	return i18nAttrDirective;
}]);

/***/ }),

/***/ "h+DX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var directivesModule = __webpack_require__("7Eh3");

function loadVal($parse) {
	return {
		restrict: "A",
		link: function link($scope, $element, $attrs) {
			var getter, setter, val, elementValue;

			if ($element.attr("type") === "checkbox") {
				elementValue = $element.is(":checked");
			} else {
				elementValue = $element.val();
			}

			val = $attrs.loadVal || elementValue;
			getter = $parse($attrs.ngModel);
			setter = getter.assign;
			setter($scope, val);
		}
	};
}

loadVal.$inject = ["$parse"];

directivesModule.directive("loadVal", loadVal);

/***/ }),

/***/ "hWdg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js__ = __webpack_require__("jYBl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raven_js__);

var windowG = window;
windowG.jQuery = __webpack_require__("juYr");
var angular = __webpack_require__("aeQg");
var angularPlugin = __webpack_require__("2laJ");
__WEBPACK_IMPORTED_MODULE_0_raven_js__["config"]("https://fbe86ea09967450fa14f299f23038a96@errors.whispeer.de/9", {
    release: {"type":"browser","version":"0.3.15"}.version,
    autoBreadcrumbs: false,
    environment: "" + "production"
})
    .addPlugin(angularPlugin, angular)
    .install();


/***/ }),

/***/ "iuSa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__("MCp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);

var LocalizationLoader = /** @class */ (function () {
    function LocalizationLoader() {
        var _this = this;
        this.fallBackLanguage = "en-US";
        this.location = "assets/js/i18n/l_";
        this.availableLanguages = [];
        this.getLanguageUrl = function (location, language) {
            return "" + location + language + ".json";
        };
        this.updateLanguageOnFail = function (language) {
            return language.length > 2 ? language.substr(0, 2) : _this.fallBackLanguage;
        };
        this.retryOnFail = function (language) {
            var otherLanguage = _this.updateLanguageOnFail(language);
            if (otherLanguage !== language) {
                return _this.loadLanguage(otherLanguage);
            }
            throw new Error("no localization found!");
        };
        this.loadOptionalLocaleExtension = function (location) {
            var url = _this.getLanguageUrl(location, _this.loadedLanguage);
            return fetch(url)
                .then(function (response) { return response.json(); })
                .catch(function (e) {
                console.warn("Failed loading language file " + url, e);
                return {};
            });
        };
        this.loadLanguage = function (language) {
            language = language.toLowerCase();
            if (!_this.fallBackLanguage || _this.availableLanguages.length === 0) {
                throw new Error("Localization module not initialized correctly");
            }
            if (_this.availableLanguages.indexOf(language) === -1) {
                return _this.retryOnFail(language);
            }
            _this.loadedLanguage = language;
            return fetch(_this.getLanguageUrl(_this.location, language))
                .then(function (response) { return response.json(); });
        };
        this.setFallBackLanguage = function (_fallBackLanguage) {
            return _this.fallBackLanguage = _fallBackLanguage;
        };
        this.setAvailableLanguages = function (_availableLanguages) {
            return _this.availableLanguages = _availableLanguages;
        };
    }
    return LocalizationLoader;
}());
/* harmony default export */ __webpack_exports__["default"] = (new LocalizationLoader());


/***/ }),

/***/ "n8tu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__asset_observer__ = __webpack_require__("SiYL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__localization_loader__ = __webpack_require__("iuSa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bluebird__ = __webpack_require__("fp6q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bluebird__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var Localize = /** @class */ (function (_super) {
    __extends(Localize, _super);
    function Localize(baseLanguage) {
        var _this = _super.call(this) || this;
        _this.dictionary = {};
        _this.dictionaryExtensions = [];
        _this.resourceFileLoaded = false;
        _this.language = window.navigator.language;
        _this.extend = function (dictionary) {
            _this.dictionaryExtensions.push(dictionary);
            _this.notify(_this.language, "localizeResourcesUpdates");
        };
        _this.loadOptionalLocaleExtension = function (location) {
            return _this.loadedPromise
                .then(function () { return __WEBPACK_IMPORTED_MODULE_1__localization_loader__["default"].loadOptionalLocaleExtension(location); })
                .then(function (dictionary) { return _this.extend(dictionary); });
        };
        // loads the language resource file from the server
        _this.initLocalizedResources = function () {
            _this.resourceFileLoaded = false;
            __WEBPACK_IMPORTED_MODULE_1__localization_loader__["default"].loadLanguage(_this.language).then(function (dict) {
                _this.dictionary = dict;
                _this.resourceFileLoaded = true;
                _this.notify(_this.language, "localizeResourcesUpdates");
                _this.onloadedCallback();
            });
        };
        _this.getLanguage = function () { return __WEBPACK_IMPORTED_MODULE_1__localization_loader__["default"].loadedLanguage || _this.language; };
        _this.setLocales = function (_dictionary) {
            this.resourceFileLoaded = true;
            this.dictionary = _dictionary;
        };
        // allows setting of language on the fly
        _this.setLanguage = function (value) {
            if (this.language !== value) {
                this.language = value;
                this.initLocalizedResources();
            }
        };
        _this.parsePluralizationMatcher = function (pluralMatcher) {
            var pluralPart = pluralMatcher.split(".."), min, max;
            if (pluralPart.length === 1) {
                min = parseInt(pluralPart[0], 10);
                max = min;
            }
            else if (pluralPart.length === 2) {
                min = parseInt(pluralPart[0], 10);
                max = parseInt(pluralPart[1], 10);
            }
            if (isNaN(min) && isNaN(max)) {
                return false;
            }
            if (isNaN(min)) {
                min = -Infinity;
            }
            if (isNaN(max)) {
                max = Infinity;
            }
            return { min: min, max: max };
        };
        _this.matchesPluralization = function (pluralMatcher, count) {
            var parsed = this.parsePluralizationMatcher(pluralMatcher);
            return parsed && parsed.min <= count && parsed.max >= count;
        };
        _this.getDictionaryValue = function (value) {
            var keys = value.split(".");
            return [_this.dictionary].concat(_this.dictionaryExtensions).reverse().map(function (dictionary) {
                return keys
                    .reduce(function (prev, attr) { return prev[attr] ? prev[attr] : prev; }, dictionary);
            }).find(function (val) { return typeof val === "string"; });
        };
        // checks the dictionary for a localized resource string
        _this.getLocalizedString = function (value, replacements) {
            if (!_this.resourceFileLoaded) {
                return "";
            }
            var entry = _this.getDictionaryValue(value);
            if (typeof entry === "undefined" || typeof entry === "object") {
                return Localize.invalidTranslation(value);
            }
            if (!replacements) {
                return entry;
            }
            return Object.keys(replacements).reduce(function (prev, element) {
                return prev.replace(Localize.getFullReplacer(element), replacements[element]);
            }, entry);
        };
        if (baseLanguage) {
            _this.language = baseLanguage;
        }
        _this.loadedPromise = new __WEBPACK_IMPORTED_MODULE_2_bluebird__(function (resolve) {
            _this.onloadedCallback = resolve;
        });
        return _this;
    }
    Localize.invalidTranslation = function (value) {
        console.warn("Invalid Translation:" + value);
        return "Missing Translation: " + value;
    };
    Localize.getReplacementString = function (replacer) {
        return "{" + replacer + "}";
    };
    Localize.escapeRegExp = function (string) {
        return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    };
    Localize.regExpFromString = function (string, mode) {
        return new RegExp(Localize.escapeRegExp(string), mode);
    };
    Localize.getFullReplacer = function (replacer) {
        return Localize.regExpFromString(Localize.getReplacementString(replacer));
    };
    return Localize;
}(__WEBPACK_IMPORTED_MODULE_0__asset_observer__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Localize);


/***/ }),

/***/ "pO06":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InternalSymbol */
function copyOwnFrom(target, source) {
    Object.getOwnPropertyNames(source).forEach(function (propName) {
        Object.defineProperty(target, propName, Object.getOwnPropertyDescriptor(source, propName));
    });
    return target;
}
var InternalSymbol = /** @class */ (function () {
    function InternalSymbol(name, props) {
        this.name = name;
        if (props) {
            copyOwnFrom(this, props);
        }
        if (Object.freeze) {
            Object.freeze(this);
        }
    }
    InternalSymbol.prototype.toString = function () {
        return "|" + this.name + "|";
    };
    return InternalSymbol;
}());

var Enum = /** @class */ (function () {
    function Enum(obj) {
        if (Array.isArray(obj)) {
            obj.forEach(function (name) {
                this[name] = new InternalSymbol(name);
            }, this);
        }
        else {
            Object.keys(obj).forEach(function (name) {
                this[name] = new InternalSymbol(name, obj[name]);
            }, this);
        }
    }
    Enum.prototype.toString = function (symbol) {
        if (this.contains(symbol)) {
            return symbol.toString();
        }
        throw new Error("symbol not part of this enum");
    };
    ;
    Enum.prototype.fromString = function (name) {
        if (name.substr(0, 1) === "|" && name.substr(-1, 1) === "|") {
            var sym = this[name.substring(1, name.length - 1)];
            if (sym instanceof InternalSymbol) {
                return sym;
            }
        }
        return null;
    };
    ;
    Enum.prototype.symbols = function () {
        var _this = this;
        return Object.keys(this).map(function (key) { return _this[key]; });
    };
    ;
    Enum.prototype.symbolPosition = function (symbol) {
        return this.symbols().indexOf(symbol);
    };
    ;
    Enum.prototype.contains = function (sym) {
        return this[sym.name] === sym;
    };
    ;
    return Enum;
}());
/* harmony default export */ __webpack_exports__["a"] = (Enum);


/***/ }),

/***/ "raBi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var State = __webpack_require__("uJ4a");
var chelper = __webpack_require__("WfiL");
var loginModule = __webpack_require__("JdNe");
var errors = __webpack_require__("a86h");
var Bluebird = __webpack_require__("fp6q");

var socketService = __webpack_require__("8I7s").default;
var Storage = __webpack_require__("IJod");

var locationService = __webpack_require__("02Tt");

var service = function service() {
	var loginState = new State.default();

	var failureCodes = {
		UNKNOWNNAME: 0,
		WRONGPASSWORD: 1,
		NOCONNECTION: 2,
		NOBUSINESSLICENSE: 3,
		UNKNOWN: 5
	};

	var sessionStorage = Storage.withPrefix("whispeer.session");
	var loginStorage = Storage.withPrefix("whispeer.login");
	var tokenStorage = Storage.withPrefix("whispeer.token");

	try {
		if (localStorage.getItem("loggedin") === "true") {
			var sid = localStorage.getItem("sid");
			var userid = localStorage.getItem("userid");
			var password = localStorage.getItem("password");

			localStorage.clear();

			//migrate to new format
			sessionStorage.set("loggedin", "true");
			sessionStorage.set("sid", sid);
			sessionStorage.set("userid", userid);
			sessionStorage.set("password", password);
		}
	} catch (e) {
		console.warn("no local storage");
	}

	var isViewForm = locationService.isLoginPage();

	sessionStorage.awaitLoading().then(function () {
		if (sessionStorage.get("loggedin") === "true") {
			locationService.mainPage();
		}
	});

	var res = {
		identifier: loginStorage.get("identifier"),
		password: "",
		failureCode: parseInt(loginStorage.get("failureCode"), 10),
		state: loginState.data,

		loginServer: function loginServer(name, password, callback) {
			return Bluebird.try(function () {
				return socketService.emit("session.token", {
					identifier: name
				});
			}).catch(function (e) {
				if (e.name === "disconnectedError") {
					throw new errors.LoginError("Login failed", { failure: failureCodes.NOCONNECTION });
				}

				console.log(e);
				throw new errors.LoginError("Login failed", { failure: failureCodes.UNKNOWNNAME });
			}).then(function (data) {
				if (data.salt.length !== 16) {
					throw new errors.LoginError("Login failed", { failure: failureCodes.SECURITY });
				}

				var hash = chelper.hashPW(password, data.salt);

				hash = chelper.hash(hash + data.token);
				return socketService.emit("session.login", {
					identifier: name,
					password: hash,
					token: data.token,
					companyToken: tokenStorage.get("token")
				}).catch(function (e) {
					if (e.name === "disconnectedError") {
						throw new errors.LoginError("Login failed", { failure: failureCodes.NOCONNECTION });
					}

					console.log(e);
					throw new errors.LoginError("Login failed", { failure: failureCodes.WRONGPASSWORD });
				});
			}).then(function (data) {
				sessionStorage.set("sid", data.sid);
				sessionStorage.set("userid", data.userid);
				sessionStorage.set("loggedin", true);
				sessionStorage.set("password", password);

				return sessionStorage.save().thenReturn(data);
			}).catch(function (e) {
				console.log(e);
				throw e;
			}).nodeify(callback);
		},

		login: function login() {
			loginState.pending();

			loginStorage.set("identifier", res.identifier || "");
			loginStorage.save().then(function () {
				return res.loginServer(res.identifier, res.password);
			}).then(function () {
				loginState.success();
				locationService.mainPage();
			}).catch(function (e) {
				loginState.failed();

				res.failureCode = e.data.failure;
				res.failedOnce = true;

				if (!isViewForm) {
					loginStorage.set("failureCode", e.failure);
					loginStorage.save().then(function () {
						locationService.loginPage();
					});
				}
			});
		}
	};

	res.loadedStorage = loginStorage.awaitLoading().then(function () {
		res.identifier = loginStorage.get("identifier");
		res.failureCode = parseInt(loginStorage.get("failureCode"), 10);

		loginStorage.remove("failureCode");
		loginStorage.save();

		return null;
	});

	return res;
};

loginModule.factory("ssn.loginDataService", service);

/***/ }),

/***/ "txTk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Bluebird = __webpack_require__("fp6q");
var runnerModule = __webpack_require__("HXS4");
var Observer = __webpack_require__("SiYL").default;

runnerModule.run(["$rootScope", function ($rootScope) {
	"use strict";

	Bluebird.setScheduler(function (cb) {
		$rootScope.$evalAsync(cb);
	});

	Observer.addAfterHook(function () {
		$rootScope.$evalAsync();
	});
}]);

/***/ }),

/***/ "uJ4a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enum__ = __webpack_require__("pO06");

var states = new __WEBPACK_IMPORTED_MODULE_0__enum__["a" /* default */](["INIT", "PENDING", "SUCCESS", "FAILED"]);
var State = /** @class */ (function () {
    function State() {
        this._state = states.INIT;
        this.data = {
            init: true,
            pending: false,
            success: false,
            failed: false
        };
    }
    State.prototype._turnOneDataTrue = function () {
        states.symbols().forEach(function (symbol) {
            var name = symbol.name.toLowerCase();
            if (this._state === symbol) {
                this.data[name] = true;
            }
            else {
                this.data[name] = false;
            }
        }, this);
    };
    ;
    State.prototype.success = function () {
        if (this._state === states.PENDING) {
            this._state = states.SUCCESS;
            this._turnOneDataTrue();
        }
    };
    ;
    State.prototype.failed = function () {
        if (this._state === states.PENDING) {
            this._state = states.FAILED;
            this._turnOneDataTrue();
        }
    };
    ;
    State.prototype.reset = function () {
        this._state = states.INIT;
        this._turnOneDataTrue();
    };
    ;
    State.prototype.pending = function () {
        this._state = states.PENDING;
        this._turnOneDataTrue();
    };
    ;
    State.prototype.isPending = function () {
        return this._state === states.PENDING;
    };
    ;
    State.prototype.isSuccess = function () {
        return this._state === states.SUCCESS;
    };
    ;
    State.prototype.isFailed = function () {
        return this._state === states.FAILED;
    };
    ;
    State.prototype.isInit = function () {
        return this._state === states.INIT;
    };
    ;
    State.prototype.getState = function () {
        return this._state;
    };
    ;
    State.prototype.getPossibleStates = function () {
        return states;
    };
    ;
    return State;
}());
/* harmony default export */ __webpack_exports__["default"] = (State);


/***/ })

},[1]);


// WEBPACK FOOTER //
// login.50378a85.js